import React from "react";
import Box from "../Box";
import styled from "styled-components";
import SelectBar from "../SelectBar";
import { CText } from "@carrefour/design-system-components-react";
import { useKpiVisibility } from "../../kpis/useKpiVisibility";

type LayoutProps = {
  children: React.ReactNode;
  title: string;
};

const BoxContainer = styled(Box)<{ gap: number }>`
  gap: ${(props) => `${props.gap}px`};
`;

const Text = styled(CText)`
  font-family: system-ui;
`;
const OperationalLayout = ({ title, children }: LayoutProps) => {

  const {isModuleExists} = useKpiVisibility();

  const priceVisibility = isModuleExists("Price");
  const detentionVisibility = isModuleExists("Detention");
  const shrinkageVisibility = isModuleExists("Shrinkage");

  let options = [];
  if(priceVisibility){
    options.push({ label: "operationnel.prix", value: "/operational/price" });
  }
  if(detentionVisibility){  
    options.push({ label: "operationnel.detention", value: "/operational/detention" });
  }
  if(shrinkageVisibility){
    options.push({ label: "operationnel.demarque", value: "/operational/shrinkage" });
  }

  return (
    <>
      { options.length > 0 && (
        <BoxContainer
          gap={16}
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
        >
          <Box>
            <SelectBar options={options} />
          </Box>
          <Box>
            <Box display={"flex"} pb={2}>
              <Text size={"l"} bold tagStyle="h3">
                {title}
              </Text>
            </Box>
            <BoxContainer gap={8} display={"flex"} flexDirection={"column"}>
              {children}
            </BoxContainer>
          </Box>
        </BoxContainer>    
      )}
    </> 
  );
};

export default OperationalLayout;
